/* eslint-disable react-hooks/exhaustive-deps */
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import PropTypes from "prop-types";
import style from "../Form.module.scss";
import { useEffect, useState } from "react";

const EVACUATIONTYPE_CONST = {
  direct:
    "direct (când apele uzate epurate sunt descărcatedirect în corpurile de apă de suprafață) ",
  indirect:
    "indirect (când apele uzate epurate sunt descărcate indirect în corpurile de apă subterane)",
};

function EvacuationType({
  systemDataTreatment,
  form,
  setSystemDataTreatment,
  setForm,
}) {
  const [evacType, setEvacType] = useState({
    direct: false,
    indirect: false,
  });

  /**
   *
   */
  useEffect(() => {
    if (systemDataTreatment.evacuationType) {
      let newEvacType = Object.assign({}, evacType);
      if (systemDataTreatment.evacuationType.includes("indirect"))
        newEvacType.indirect = true;
      else if (systemDataTreatment.evacuationType.includes("direct"))
        newEvacType.direct = true;

      setEvacType(newEvacType);
    }
  }, [systemDataTreatment.evacuationType]);

  /**
   *
   * @param {*} event
   * @param {*} type
   * change checkbox
   */
  function onChange(event, type) {
    const evacTypeText = type === "direct" ? "direct" : "indirect";
    let newSystemDataTreatment = Object.assign({}, systemDataTreatment);
    let newEvacType = Object.assign({}, evacType);
    newEvacType[type] = event.target.checked;
    setEvacType(newEvacType);
    if (event.target.checked) {
      newSystemDataTreatment.evacuationType += `${evacTypeText}, `;
      newSystemDataTreatment.evacuationType =
        newSystemDataTreatment.evacuationType.trim();
    } else {
      let value = newSystemDataTreatment.evacuationType.split(",");
      const find = value.findIndex((v) => v.includes(evacTypeText));
      if (find >= 0) value.splice(find, 1);
      value = value.join();
      newSystemDataTreatment.evacuationType = value;
      newSystemDataTreatment.evacuationType =
        newSystemDataTreatment.evacuationType.trim();
    }
    setSystemDataTreatment({ ...systemDataTreatment, newSystemDataTreatment });
    setForm({ ...form, systemDataTreatment: newSystemDataTreatment });
  }

  return (
    <>
      <FormControl style={{ marginTop: 15 }}>
        <FormLabel className={style.formLabel}>Tip evacuare</FormLabel>
        <FormControlLabel
          control={
            <Checkbox
              checked={evacType.direct}
              onChange={(e) => onChange(e, "direct")}
            />
          }
          label={EVACUATIONTYPE_CONST.direct}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={evacType.indirect}
              onChange={(e) => onChange(e, "indirect")}
            />
          }
          label={EVACUATIONTYPE_CONST.indirect}
        />
      </FormControl>
    </>
  );
}

export default EvacuationType;
EvacuationType.propTypes = {
  systemDataTreatment: PropTypes.object,
  form: PropTypes.object,
  setSystemDataTreatment: PropTypes.func,
  setForm: PropTypes.func,
};
